import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  cardFlightInfoBox: {
    width: '100%',
    flexGrow: '1',

    '&:nth-of-type(1)': {
      paddingBottom: 24,
    },
    '&:nth-of-type(2)': {
      borderTop: `1px solid ${Theme.palette.gray[250]}`,
      paddingTop: 24,

      [Theme.breakpoints.up('xl')]: {
        paddingLeft: '24px',
        borderLeft: `1px solid ${Theme.palette.gray[250]}`,
        paddingTop: '0',
        borderTop: 'none',
      },
    },

    '&.summary:nth-of-type(2)': {
      borderTop: `1px solid ${Theme.palette.gray[250]}`,
      paddingTop: 24,
      borderLeft: 0,
      paddingLeft: 0,
    },
  },
  justifiedFlightInfo: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',

    [Theme.breakpoints.up('lg')]: {
      flexWrap: 'nowrap',
    },

    '& span': {
      display: 'flex',
      color: Theme.palette.gray[500],
    },
  },

  isBrowsePath: {
    flexWrap: 'wrap',
  },
  flightDateWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'wrap',
    '@media (min-width: 1280px)': {
      flexWrap: 'nowrap',
    },

    '& .details-actions': {
      display: 'flex',
      gap: 20,
      flex: '0 0 auto',
      justifyContent: 'flex-end',
      marginLeft: 'auto',
      '@media (min-width: 1280px)': {
        marginLeft: '16px',
      },
    },
  },
  summaryLayout: {
    '@media (min-width: 1280px)': {
      '& $flightInfoInline': {
        order: 2,
      },
      '& .details-actions': {
        order: 3,
      },
    },
  },
  confirmationLayout: {
    '@media (min-width: 1280px)': {
      flexWrap: 'wrap',
      '& .details-actions': {
        marginLeft: 'auto',
      },
      '& $iconAirlineAndDate': {
        width: 'auto',
        borderRight: 'none',
        paddingRight: 0,
      },
      '& $flightInfoInline': {
        flex: '0 0 100%',
        marginLeft: 0,
        marginTop: '12px',
      },
      '& $confirmationNumber': {
        flex: '0 0 100%',
        margin: '10px 0 0 0',
        maxWidth: 'none',
      },
    },
  },
  flightAirlineLogo: {
    height: '26px',
    width: '26px',
    position: 'relative',
    [Theme.breakpoints.down('md')]: {
      top: '0',
    },
    [Theme.breakpoints.down('sm')]: {
      height: '21px',
      width: '21px',
    },
  },
  flightDate: {
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[2],
    color: Theme.palette.primary.main,
    [Theme.breakpoints.down('sm')]: {
      fontSize: Theme.typography.size[3],
    },
  },
  flightDatePanel: {
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[3],
    color: Theme.palette.primary.main,
    marginLeft: '10px',
  },
  flightInfo: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '20px',
    gap: '10px',
    justifyContent: 'space-between',
  },

  flightInfoWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  firstColumn: {
    minWidth: '210px',
    [Theme.breakpoints.up('md')]: {
      minWidth: '360px',
    },
  },
  firstColumnPanel: {
    marginRight: '83px',
    [Theme.breakpoints.down('lg')]: {
      marginRight: '-6px',
    },
  },
  secondColumn: {
    [Theme.breakpoints.up('lg')]: {
      width: '100px',
      marginRight: '54px',
    },
  },
  thirdColumn: {
    [Theme.breakpoints.up('lg')]: {
      width: '90px',
      marginRight: '54px',
    },
  },
  fourthColumn: {
    '& div': {
      textAlign: 'right',
    },
    [Theme.breakpoints.up('lg')]: {
      width: '100px',
    },
  },
  flightInfoDownLgHide: {
    [Theme.breakpoints.down('lg')]: {
      display: 'none',
    },
  },
  flightInfoDownLgHidePanel: {
    display: 'none',
  },
  flightInfoDownLgShow: {
    display: 'none',
    [Theme.breakpoints.down('lg')]: {
      display: 'block',
    },
  },
  flightInfoDownLgShowPanel: {
    display: 'block',
  },
  flightInfoPrimary: {
    fontSize: Theme.typography.size[2],
    color: Theme.palette.gray[750],
    fontFamily: Theme.typography.base.semiBold,
  },
  flightInfoSecondary: {
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[1],
    color: Theme.palette.gray[500],
    textWrap: 'nowrap',
    marginTop: '5px',
    '& p': {
      margin: '0',
      lineHeight: '150%',
    },
    [Theme.breakpoints.up('lg')]: {
      width: '100%',
    },
    [Theme.breakpoints.down('lg')]: {
      maxWidth: '430px',
    },
    [Theme.breakpoints.down('sm')]: {
      textWrap: 'wrap',
    },
  },
  flightInfoSecondaryExtraInfo: {
    display: 'none',
    marginTop: '5px',
    '& p': {
      margin: '0',
      lineHeight: '150%',
    },
    [Theme.breakpoints.down('lg')]: {
      display: 'flex',
      maxWidth: '380px',
    },
    [Theme.breakpoints.down('md')]: {
      maxWidth: '430px',
    },
  },
  flightInfoSecondaryExtraInfoDownSmHide: {
    [Theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },

  flightInfoSecondaryExtraInfoDownSmHidePanel: {
    display: 'none',
  },
  flightInfoSecondaryExtraInfoDownSmShow: {
    display: 'none',
    [Theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  flightInfoSecondaryExtraInfoDownSmShowPanel: {
    display: 'block',
  },
  flightInfoOperatedBy: {
    display: 'block',
    marginTop: '5px',
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[1],
    color: Theme.palette.gray[500],
    lineHeight: '150%',
  },

  layoverDaysReview: {
    fontSize: 'smaller',
    position: 'relative',
    top: '-5px',
  },
  flightDetails: {
    textDecoration: 'underline',
    cursor: 'pointer',
    margin: 0,
    textWrap: 'nowrap',
    alignSelf: 'normal',
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[1],
    lineHeight: '150%',
    color: Theme.palette.primary.light,
    textAlign: 'right',
  },
  flightDetailsPanel: {
    display: 'none',
  },
  flightDetailsSM: {
    display: 'none',
    fontSize: Theme.typography.size[1],
    lineHeight: '150%',
    marginTop: '10px',
    color: Theme.palette.primary.light,
    [Theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  flightDetailsSMPanel: {
    display: 'block',
    fontSize: Theme.typography.size[1],
    lineHeight: '150%',
    marginTop: '10px',
    color: Theme.palette.primary.light,
  },
  iconAirlineAndDate: {
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'stretch',
    paddingRight: '24px',
    '@media (min-width: 1280px)': {
      borderRight: `1px solid ${Theme.palette.gray[250]}`,
    },
    [Theme.breakpoints.up('xl')]: {
      width: '378px',
    },
  },
  airlineInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: '10px',
  },
  airlineNameRow: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '4px',
  },
  airlineName: {
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[2],
    color: Theme.palette.gray[800],
    lineHeight: '150%',
    [Theme.breakpoints.down('sm')]: {
      fontSize: Theme.typography.size[3],
    },
  },
  airlineFlightNum: {
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[1],
    color: Theme.palette.gray[500],
    lineHeight: '150%',
  },
  flightDateRow: {
    marginTop: '12px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  flightInfoInline: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '12px',
    flex: '0 0 100%',
    minWidth: 0,
    marginLeft: 0,
    marginTop: '12px',
    '@media (min-width: 1280px)': {
      flex: 1,
      marginLeft: '24px',
      marginTop: 0,
    },
  },
  timelineDeparture: {
    textAlign: 'left',
    flex: '0 0 auto',
    '& > p': { margin: 0 },
  },
  timelineArrival: {
    textAlign: 'right',
    flex: '0 0 auto',
    '& > p': { margin: 0 },
  },
  timelineRoute: {
    flex: '1 1 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '3px',
    minWidth: 0,
  },
  timelineTime: {
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[2],
    color: Theme.palette.gray[750],
    margin: 0,
    whiteSpace: 'nowrap',
    '@media (min-width: 1280px)': {
      fontSize: Theme.typography.size[4],
    },
  },
  timelineCity: {
    fontSize: Theme.typography.size[1],
    color: Theme.palette.gray[500],
    margin: 0,
  },
  timelineRouteLabel: {
    fontSize: Theme.typography.size[1],
    color: Theme.palette.gray[500],
    margin: 0,
    whiteSpace: 'nowrap',
  },
  timelineRouteLine: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  timelineDot: {
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    backgroundColor: Theme.palette.gray[750],
    flexShrink: 0,
  },
  timelineLineSeg: {
    flex: '1 1 0',
    minWidth: 0,
    height: '1px',
    borderTop: `1px dashed ${Theme.palette.gray[500]}`,
  },
  timelineFlightIcon: {
    fontSize: '16px',
    color: Theme.palette.gray[400],
    flexShrink: 0,
    margin: '0 4px',
    transform: 'rotate(90deg)',
  },
  timelineDayOffset: {
    fontSize: Theme.typography.size[0],
    color: Theme.palette.primary.light,
    verticalAlign: 'super',
    marginLeft: '2px',
  },
  timelinePassengers: {
    textAlign: 'right',
    flexShrink: 0,
    '& > p': { margin: 0 },
  },
  timelinePassengerText: {
    fontSize: Theme.typography.size[1],
    color: Theme.palette.gray[500],
    whiteSpace: 'nowrap',
    margin: 0,
  },
  withReservationNumber: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  confirmationNumber: {
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[2],
    color: Theme.palette.primary.main,
    lineHeight: '150%',
    marginTop: '10px',
    textWrap: 'pretty',
    '& .singleLine': {
      textWrap: 'nowrap',
    },
    [Theme.breakpoints.up('md')]: {
      margin: '0px 25px',
    },
    [Theme.breakpoints.only('lg')]: {
      maxWidth: '205px',
      margin: '0px 15px 0px 25px',
    },
  },
  brandName: {
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[1],
    fontWeight: 400,
    lineHeight: '150%',
    color: Theme.palette.primary.main,
    margin: '4px 0 8px 0',
  },
  chipsRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    alignItems: 'center',
    marginBottom: '8px',
  },
  propChip: {
    backgroundColor: '#E8F1FE',
    color: Theme.palette.primary.main,
    fontWeight: 600,
    borderRadius: '12px',
    '& .MuiChip-label': { padding: '0 10px' },
  },
  fareDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginTop: '16px',
    [Theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      gap: '24px',
    },
  },
  fareDetailsLeft: {
    [Theme.breakpoints.up('md')]: {
      flex: '0 0 45%',
      maxWidth: '45%',
    },
  },
  fareDetailsRight: {
    flex: 1,
    minWidth: 0,
  },
}));

export default useStyles;
